'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Chip, Input } from '@common/components';
import { SvgChevrondown } from '@common/icon';
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useState } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import type { SEARCH_PARAMS_TYPE } from '@/constants';
interface TimeFieldWithBottomDrawerProps {
  value: [Exclude<SEARCH_PARAMS_TYPE.EMERGENCY_ROOM_PARAMS['emergencyRoomDayType'], undefined>, number];
  onChange?: (value: TimeFieldWithBottomDrawerProps['value']) => void;
}
const TIME_LIMIT = {
  MIN: 8,
  MAX: 24
};
enum DAY_TYPE {
  WEEKDAY = '주중',
  WEEKEND = '주말',
  HOLIDAY = '휴일',
}
export const TimeFieldWithBottomDrawer = t0 => {
  const $ = _c(40);
  const {
    value,
    onChange
  } = t0;
  const [isOpened, setIsOpened] = useState(false);
  const [tempValue, setTempValue] = useState(value);
  const [dayType, time] = tempValue;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  let t2;
  let t3;
  if ($[1] !== emblaApi || $[2] !== isOpened || $[3] !== time) {
    t2 = () => {
      if (!isOpened || !emblaApi) {
        return;
      }
      const timer = setTimeout(() => {
        emblaApi.scrollTo(time - TIME_LIMIT.MIN, false);
      }, 300);
      return () => clearTimeout(timer);
    };
    t3 = [isOpened, time, emblaApi];
    $[1] = emblaApi;
    $[2] = isOpened;
    $[3] = time;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgChevrondown className="size-20 text-Gray-700" name={"\uC5F4\uAE30"} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${DAY_TYPE[value[0]]} · ${value[1]}:00 예정`;
  let t6;
  if ($[7] !== value) {
    t6 = () => {
      setTempValue(value);
      setIsOpened(true);
    };
    $[7] = value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <Input className="font-400" id="time" placeholder={"\uBC29\uBB38 \uC608\uC815 \uC77C\uC2DC\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."} rightContent={t4} type="button" value={t5} onClick={t6} />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setIsOpened(false);
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h3 className="mx-30 mb-32 font-700 typo-body1">방문 예정 일시를 선택해주세요</h3>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = Object.entries(DAY_TYPE);
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== dayType || $[16] !== time) {
    t11 = <dd className="mx-30 flex gap-16">{t10.map(t12 => {
        const [key, value_0] = t12;
        return <Chip key={key} checked={dayType === key} className="size-48 px-0 flex-center" onCheckedChange={checked => {
          if (checked) {
            setTempValue([key as keyof typeof DAY_TYPE, time]);
          }
        }}>{value_0}</Chip>;
      })}</dd>;
    $[15] = dayType;
    $[16] = time;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <dt className="mx-30 mb-16 mt-32 font-600 typo-body3">방문 시간</dt>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== dayType || $[20] !== time) {
    t13 = new Array(TIME_LIMIT.MAX - TIME_LIMIT.MIN + 1).fill(0).map((_, index) => {
      const value_1 = TIME_LIMIT.MIN + index;
      return <div key={value_1} className="w-fit flex-[0_0_auto] first:ml-30 last:mr-30"><Chip checked={time === value_1} onCheckedChange={checked_0 => {
          if (checked_0) {
            setTempValue([dayType, value_1]);
          }
        }}>{String(TIME_LIMIT.MIN + index).padStart(2, "0")}:00</Chip></div>;
    });
    $[19] = dayType;
    $[20] = time;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13) {
    t14 = <div className="flex gap-6">{t13}</div>;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== emblaRef || $[25] !== t14) {
    t15 = <dd><div className="overflow-hidden" ref={emblaRef}>{t14}</div></dd>;
    $[24] = emblaRef;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t11 || $[28] !== t15) {
    t16 = <dl>{t11}{t12}{t15}</dl>;
    $[27] = t11;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== onChange || $[31] !== tempValue) {
    t17 = <footer className="mt-32 w-full px-30 py-16"><Button className="w-full" onClick={() => {
        onChange?.(tempValue);
        setIsOpened(false);
      }}>선택 완료</Button></footer>;
    $[30] = onChange;
    $[31] = tempValue;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== isOpened || $[34] !== t16 || $[35] !== t17) {
    t18 = <ResponsiveDialog opened={isOpened} onClose={t8} drawerType="bottom" drawerNoPadding={true}>{t9}{t16}{t17}</ResponsiveDialog>;
    $[33] = isOpened;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t18 || $[38] !== t7) {
    t19 = <label className="flex flex-col gap-10 font-500 text-Gray-900 typo-body3" htmlFor="time">방문 예정 일시{t7}{t18}</label>;
    $[37] = t18;
    $[38] = t7;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
};